<template>
  <!-- 能源分项 -->
   <div class="energysubarea">
          <div class="con">
                <div class="Files-top">
                    <div class="ic-left">
                    <span>能源分项</span>
                    </div>
                    <div class="btns">
                          <el-button type="primary" @click="add_ed(0)" class="last-el-button">新增</el-button>
                    </div>
                </div>
                <div class="mytable" style="margin-top:20px">
                    <el-table id="demo" :height="heights+60" v-loading="loading" stripe :data="tableData" border style="width: 100%"
                          row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                          <template slot="empty">
                            <span class="noData">
                              <img src="@/assets/noData.png" alt="暂无数据">
                              <span class="text">暂无数据</span>
                            </span>
                          </template>
                          <el-table-column type="index" label="#" width="90" align="center">
                          </el-table-column>
                          <el-table-column label="名称" align="left">
                            <template slot-scope="{row}">
                              <el-link type="primary" :class="{'actived':mainId===row.id}" @click="shebei(row)">{{ row.name }}
                              </el-link>
                            </template>
                          </el-table-column>
                          <el-table-column prop="code" label="编码" >
                          </el-table-column>
                          <el-table-column label="操作" align="center" width="450" >
                            <template #default="{row}">
                              <div class="btnss" style="display: flex;justify-content: center; align-items: center;">
                                
                                 <span style="color:#368ED9" @click="add_ed(row.id)" v-show="row.upId == 0">添加设备</span>
                                <span class="line" v-show="row.upId == 0"></span>
                                 <span style="color:#368ED9" @click="shebei(row)" v-show="row.upId != 0">设备列表</span>
                                <span class="line" v-show="row.upId != 0"></span>
                               <span style="color:#368ED9" @click="edit_ed(row)" >编辑</span>
                                <span class="line"></span>
                                <span style="color:#FF1D1D" @click="delete_fn(row.id)">删除</span>
                              </div>
                            </template>
                          </el-table-column>
                    </el-table>
                </div>
                <el-drawer title="" :visible.sync="drawer" :with-header="false"  :size="drawerSize">
                   <div class="drawer-con">
                      <div class="Files-top">
                        <div class="ic-left">
                        <span>设备列表({{deviceName}})</span>
                        </div>
                        <div class="btns">
                            
                        </div>
                      </div>
                      <div class="dracaozuo" style="display:flex">
                          <div class="dratable" style="width:345px;margin-top:20px">
                                <el-table ref="multipleTable" :data="deviceTableData" tooltip-effect="dark" style="width: 100%"
                                    :height="heights" border @selection-change="handleSelectionChange">
                                    <template slot="empty">
                                      <span class="noData">
                                        <img src="@/assets/noData.png" alt="暂无数据">
                                        <span class="text">暂无数据</span>
                                      </span>
                                    </template>
                                    <el-table-column type="selection" width="44" align="center"> </el-table-column>
                                    <el-table-column label="设备号" prop="no" width="120"> </el-table-column>
                                    <el-table-column prop="name" label="设备名称" > </el-table-column>

                                  </el-table>
                          </div>
                           <div class="dra-btns">
                               <div class="left-add" @click="saveDevice">添加<img src="@/assets/left.png" alt=""></div>
                               <div class="del" @click="device_Del">移除<img src="@/assets/right.png" alt=""></div>
                           </div>
                          <div class="dratree" :style="{'width':'300px','height':`${heights+150}px`}">
                               <div class="search">
                                  <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                                </div>
                                <el-scrollbar style="height:calc(100% - 40px);width: 100%;">
                                  <el-tree :data="deviceData" show-checkbox node-key="numNo" :props="defaultProps" @check="currentChecked"
                                      :filter-node-method="filterNode" default-expand-all ref="tree" >
                                      <span class="custom-tree-node" slot-scope="{node}">
                                        <img src="../../../public/static/image/elTree/1.9.png"  v-show="node.data.Content.Category=='Organization'"/>
                                         <img src="../../../public/static/image/elTree/2.1.png"  v-show="node.data.Content.Category=='Device'"/>
                                           <span style="padding-left: 5px;">{{node.data.Content.Name}}</span>
                                      </span>
                                    </el-tree>
                                  </el-scrollbar>
                          </div>
                         </div>
                   </div>

                </el-drawer>
              <!-- 新增修改 -->
            <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
              width="30%" center>
              <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
                <el-form-item label="名称:" prop="name">
                  <el-input v-model="temp.name"></el-input>
                </el-form-item>
                <el-form-item label="编码:" prop="code">
                  <el-input v-model="temp.code"></el-input>
                </el-form-item>
                <el-form-item label="应用类型组:">
                  <el-select v-model="temp.appType" filterable placeholder="请选择应用类型组" clearable>
                    <el-option v-for="(item,i) in options" :key="i" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="应用类型:">
                  <el-select v-model="temp.appTypeNo" filterable placeholder="请选择应用类型" clearable>
                    <el-option v-for="(item,i) in typeOptions" :key="i" :label="item.name" :value="item.no">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <template #footer>
                <span class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
                  </el-button>
                </span>
              </template>
            </el-dialog>
          </div>
    </div>
</template>
<script>
  //   import { EnergySubitem, GetEnergySubitem, EnergySubitemAdd, EnergySubitemDelete, EnergySubitemEdit, EnergySubitemAll, GetEnergySubitemVirtualDevice, SaveEnergySubitemVirtualDevice } from "@/utils/request";
  //   import request from "@/utils/request";
  //   import { parseTime } from "@/utils";
  import Pagination from "../../components/module/Pagination"; // 分页
  import {getReadDeviceTree} from "../../api/abbNewApi";
  import {findAllSubentry,saveEnergySubentry,subentryDelete,subentryFindDevice,subentrySaveDevice,subentryDeleteDevice} from "../../api/energySubentry";
  import {getAllTypeByGroup,getAppTypeByGroupId} from "../../api/energySubType";
  export default {
    components: {Pagination},
    data () {
      return {
        drawerSize:"800px",
         heights: document.getElementById('app').clientHeight-255,//屏幕高度 - 导航栏高度
        drawer:false,
        loading: true,
        dialogTableVisible: false,
        list: [],//绑定设备列表數據
        toggleRowData: [],
        total2: 0,
        total: 0,
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        tableData: [],

        options: [],
        typeOptions: [],
        dialogVisible: false,
        rules: {
          appTypeNo: [
            {required: true,message: '请选择应用类型',trigger: 'blur'}
          ],
          name: [
            {required: true,message: '请输入区域名称',trigger: 'blur'}
          ],
          code: [
            {required: true,message: '请输入区域编码',trigger: 'blur'}
          ],
          appType: [
            {required: true,message: '请选择应用类型组',trigger: 'change'}
          ],

        },
        conditions: {},
        mainId: '',
        options: [],
        topLevel: 0,
        deviceName: "",
        searchName: "",
        multipleSelection: [],
        deviceTableData: [],
        deviceTableDataCopy: [],
        checkedNodes: [],
        //以下是设备列表树形
        filterText: '',
        deviceData: [],//设备树形结构
        defaultProps: {
          children: 'ChildDatas',
          label: 'Content.Name'
        },
        flag: false

      };
    },
    mounted () {
      //应用类型编码
      getAllTypeByGroup().then(res => {
        //  console.log("res应用类型",res);
        this.options=res.data;
        this.getList();//获取列表数据 
      })
      //获取设备树
      var num = 0
      getReadDeviceTree().then(res => {
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.ChildDatas.length!=0) {
                // console.log("row.ChildDatas",row);
                row.numNo = num++
                getStr(row.ChildDatas)
              } else {
                 row.numNo = num++
                row['disabled']=false
              }
            })
          }
          getStr(res.data)
        }
        recursiveFunction()
        this.deviceData=res.data
        // console.log("设备列表",this.deviceData);
      })
    },
    watch: {
      'temp.appType': function(val) {
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }

        getAppTypeByGroupId({'groupId': val}).then(res => {
          // console.log(res);
          if(res.code==200) {
            this.typeOptions=res.data
          }
        })
      },
      searchName (val) {
        if(val=='') {
          this.deviceTableData=this.deviceTableDataCopy
        }
      },
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
      filterText (val) {
        this.$refs.tree.filter(val);
      },
    },
    methods: {
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        this.checkedNodes=SelectedObj.checkedNodes
        this.checkedNodes=this.checkedNodes.filter(item => item.Content.Category=='Device')
      },
      // 绑定设备
      saveDevice () {
        if(this.deviceName=='') {
          this.$message({type: 'warning',message: '请选择区域'});
          return
        }
        if(this.checkedNodes.length==0) {
          this.$message({type: 'warning',message: '请勾选设备'});
          return
        }
        var ids=""
        this.checkedNodes.forEach(item => ids+=','+item.Id)
        ids=ids.slice(1)
        var d={
          "subitemId": this.mainId,
          "nos": ids
        };
        subentrySaveDevice(d).then(res => {
          // console.log(res);
          if(res.code==200) {
            //  this.checkedNodes = []
            this.$message({type: 'success',message: '绑定成功'});
            this.$refs.tree.setCheckedKeys([]);
            this.getDevice(this.mainId)
          } else {
            this.$message({type: 'error',message: `绑定失败,${res.message}`});
          }
        })


      },
      //输入关键字进行过滤
      filterNode (value,data) {
        if(!value) return true;
        return data.Content.Name.indexOf(value)!==-1;
      },

      //点击表格名称
      shebei (v) {
        this.mainId=v.id;
        this.deviceName=v.name
        this.drawer = true
        this.flag=false
        if(v.upId==0) {
          this.deviceName='不可绑定设备给单位'
          this.deviceTableData=[]
          this.flag=true
          // this.getReadDeviceTree()
          return
        }
        this.getDevice(this.mainId)
      },
      //移除分项的关联设备
      device_Del () {
        if(this.deviceName=='') {
          this.$message({type: 'warning',message: '请选择区域'});
          return
        }
        // console.log("this.multipleSelection",this.multipleSelection);
        if(this.multipleSelection.length==0) {
          this.$message({type: 'warning',message: '请勾选需要删除的设备!'});
          return
        }
        var ids=""
        this.multipleSelection.forEach(item => ids+=','+item.no)
        // console.log(ids.split(1));
        ids=ids.slice(1)
        var d={
          'subitemId': this.mainId,
          'nos': ids
        }

        subentryDeleteDevice(d).then(res => {
          if(res.code==200) {
            this.$message({type: 'success',message: '移除成功!'});
            this.getDevice(this.mainId)
          } else {
            this.$message({type: 'success',message: `移除失败,${res.message}`});
          }
        })

      },
      //搜索设备列表
      search_fn () {
        this.deviceTableData=this.deviceTableDataCopy.filter((item) => item.name.includes(this.searchName));
      },


      // 获取绑定列表
      getDevice (id) {

        subentryFindDevice({'subitemId': id}).then(res => {
          // console.log("绑定列表res",res);
          if(res.code==200) {
            this.deviceTableData=res.data
            this.deviceTableDataCopy=res.data
            var a=this.deviceData
            var recursiveFunction=function() {
              const getStr=function(list) {
                list.forEach(function(row) {
                  if(row.ChildDatas.length!=0) {
                    getStr(row.ChildDatas)
                  } else {
                    row.disabled=false
                    res.data.forEach(item => {
                      if(row.Content.Id==item.no) {
                        // console.log("row.ChildDatas",row);
                        row.disabled=true
                      }
                    })

                  }
                })
              }
              getStr(a)
            }
            recursiveFunction()
          }
        })

      },
      // 勾选
      handleSelectionChange (val) {
        this.multipleSelection=val;
      },



      // 删除分项菜单
      delete_fn (v) {
      

        this.$confirm('是否删除此条内容','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           subentryDelete({'id': v}).then(data => {
              if(data.code==200) {
                this.$message({showClose: true,message: '删除成功',type: 'success'});
                this.getList();
              } else {
                this.$message({
                  showClose: true,
                  message: data.message
                });
              }
            })
        }).catch(() => {
          // ...
        });

      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {

            this.temp.upId=this.topLevel
            this.temp.uid=""
            this.typeOptions.forEach(item => {
              if(item.no==this.temp.appTypeNo) {
                this.temp.appTypeName=item.name
              }
            })

            saveEnergySubentry(this.temp).then(data => {
              // console.log("添加顶级菜单",data);
              this.temp={}
              if(data.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }

            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { UpId: v || null };
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {

            var d={
              "code": this.temp.code,
              "name": this.temp.name,
              "uid": this.temp.id,
              "appType": this.temp.appType,
              "appTypeNo": this.temp.appTypeNo,
              "upId": this.temp.upId
            }
            this.typeOptions.forEach(item => {
              if(item.no==this.temp.appTypeNo) {
                d.appTypeName=item.name
              }
            })

            saveEnergySubentry(d).then(data => {
              if(data.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }

            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },
      //获取列表数据
      getList () {
        this.loading=true
        setTimeout(() => {
           this.loading=false
        }, 3000);
        findAllSubentry().then(res => {
          // console.log("列表数据",res);
          if(res.code==200) {
            this.tableData=res.data
            this.loading=false
          }
        })


      }
    }
  };
</script>

<style lang="scss" scoped>
 .line {
  margin: 0px 12px;
  display: inline-block;
  width: 1px;
  height: 18px;
  background-color: #E6E6E6;
}
.more {
  position: relative;
  .more-dir {
    z-index: 10;
      position: absolute;
      width: 120px;
      height: 154px;
      top: 12px;
      right: -23px;
      box-sizing: border-box;
      padding-top: 14px;
      background: url(../../assets/unifyImg/more.png) no-repeat;
      background-size: 100% 100%;
      p {
         font-size: 13px;
         color: #999999;
         margin-top: 15px;
         &:hover {
           color: #368ED9;
         }
      }
  }
}
/deep/.el-table .cell {
  overflow: visible;
}
.drawer-con {
   padding: 12px 20px 20px 20px;
}
.dra-btns {
   width: 88px;
   margin: 0px 12px;
   margin-top: 240px;
   .left-add,.del{
     width: 88px;
     height: 32px;
     background-color: #368ED9;
     color: #fff;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 2px;
   }
   .del {
       background-color: #ED6547;
       margin-top: 40px;
   }
}
.dratree {
  padding: 20px 12px 12px 12px;
  box-sizing: border-box;
   border-left:1px solid #ccc
  
}
  .energysubarea {
      .con{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background-color: #fff;
          padding: 12px 20px 20px 20px;
       
	    }
        .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
      }
      .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
      }
       /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    
  }

</style>